const Header = {
  lastScrollTop: -1,
  scrollTop: window.scrollY,
  header: document.querySelector('#header'),

  setScroll: function (scrollTop, lastScrollTop) {
    const _this = this;

    if (scrollTop <= 0) {
      _this.header.classList.add('scroll-up');
      _this.header.classList.remove('scroll-down');
      _this.header.classList.add('on-top');
    } else {
      if (_this.header.classList.contains('on-top')) {
        _this.header.classList.remove('on-top');
      }
      if (scrollTop > lastScrollTop) {
        _this.header.classList.add('scroll-down');
        _this.header.classList.remove('scroll-up');
      } else {
        _this.header.classList.add('scroll-up');
        _this.header.classList.remove('scroll-down');
      }
    }
  },

  searchButton: function () {
    const searchButton = document.querySelector('[data-action="show-form-search"]');
    const searchButtonClose = document.querySelectorAll('[data-action="hide-form-search"]');
    const formSearch = document.querySelector('.search-form');
    const formSearchInput = document.querySelector('.search-form input');

    if (!formSearch) return;

    // Reactive search
    const reactiveSearchContainer = document.querySelector('[data-search-result]');
    const searchBackground = document.querySelector('.reactive-search-background');

    searchButton &&
      searchButton.addEventListener('click', (e) => {
        e.preventDefault();

        Header.showRecentSearchs();

        formSearch.classList.toggle('-active', !formSearch.classList.contains('-active'));

        if (formSearch.classList.contains('-active')) {
          formSearchInput && formSearchInput.dispatchEvent(new Event('input'));
        }

        formSearchInput && formSearchInput.focus();

        if (window.innerWidth > 768) {
          document.addEventListener('scroll', () => {
            formSearch.classList.remove('-active');

            // Reactive search
            reactiveSearchContainer && reactiveSearchContainer.classList.remove('-active');
            searchBackground && searchBackground.classList.remove('-active');
          });
        }
      });

    searchButtonClose.length > 0 &&
      searchButtonClose.forEach((close) => {
        close.addEventListener('click', () => {
          formSearch.classList.remove('-active');

          // Reactive search
          reactiveSearchContainer && reactiveSearchContainer.classList.remove('-active');
          searchBackground && searchBackground.classList.remove('-active');
        });
      });

    // Desativa o popup de busca - quando necessário
    formSearch.addEventListener('click', (e) => {
      if (e.target.className == 'header-search -active') {
        formSearch.classList.remove('-active');

        // Reactive search
        reactiveSearchContainer && reactiveSearchContainer.classList.remove('-active');
        searchBackground && searchBackground.classList.remove('-active');
      }
    });

    formSearch.addEventListener('submit', (event) => {
      event.preventDefault();
      Header.setRecentSearchs(formSearchInput);
      formSearch.submit();
    });
  },

  setRecentSearchs: function (formSearchInput) {
    let currentSearch = formSearchInput.value;
    let recentSearchs = sessionStorage.getItem('recentSearchs');

    if (recentSearchs) {
      let arrayRecents = recentSearchs.split('|');

      //Evita repetição
      if (!arrayRecents.includes(currentSearch)) {
        recentSearchs += '|' + currentSearch;
        return;
      }
    } else {
      recentSearchs = currentSearch;
    }

    sessionStorage.setItem('recentSearchs', recentSearchs);
  },

  showRecentSearchs: function () {
    const recentSearchs = sessionStorage.getItem('recentSearchs');
    const recentSearchsContainer = document.querySelector('[data-recent-searchs]');

    if (recentSearchs && recentSearchsContainer) {
      const containerToInsert = recentSearchsContainer.querySelector('.search-terms');
      containerToInsert.innerHTML = '';
      let searchTerms = recentSearchs.split('|');

      searchTerms.forEach((searchTerm) => {
        let elementToInsert = document.createElement('a');
        let searchParam = encodeURIComponent(searchTerm);

        elementToInsert.setAttribute('href', `/busca?q=${searchParam}`);
        elementToInsert.innerHTML = searchTerm;
        containerToInsert.appendChild(elementToInsert);
      });

      recentSearchsContainer.classList.add('-visible');
    }
  },
  init: function () {
    const _this = this;

    _this.setScroll(_this.scrollTop, _this.lastScrollTop);
    _this.searchButton();

    // Atualiza o header quando a page recebe scroll
    window.addEventListener('scroll', function () {
      const newSt = window.scrollY;

      _this.setScroll(newSt, _this.lastScrollTop);
      _this.lastScrollTop = newSt;
    });
  },
};

export default Header;
